import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.ul`
  list-style: none;
  display: flex;
  height: 30px;
  background: ${colors.navbar.bg};
`;

interface BtnNavbarProps {
  $highlight?: boolean;
}

export const BtnNavbar = styled.li<BtnNavbarProps>`
  height: 100%;
  line-height: 30px;

  a {
    display: block;
    color: ${props =>
      props.$highlight ? colors.errorLight : colors.text.link};
    padding: 0 25px;
    font-weight: bold;
    text-decoration: none;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${colors.navbar.hover};
      color: ${props =>
        props.$highlight ? colors.errorLight : colors.text.link};
      text-decoration: none;
    }
  }
`;
